import React, { useEffect, useRef, useState } from 'react';
import { Engine, type Scene } from '../intro-engine/Engine';

// Renders a single gb4k.fr V2 engine scene (fullscreen shader) inside a page.
// Used to bring the V2 Chronotunnel and Menger scenes into the V1 site.

interface Props { make: () => Scene; }

const EngineScene: React.FC<Props> = ({ make }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const cv = canvasRef.current;
    if (!cv) return;
    let engine: Engine;
    try { engine = new Engine(cv); } catch { setFailed(true); return; }
    engine.register('s', () => Promise.resolve({ default: make }));
    engine.start();
    void engine.setScene('s');
    return () => { engine.stop(); };
  }, [make]);

  if (failed) return <div className="engine-scene engine-fail">WebGL2 required.</div>;
  return <div className="engine-scene"><canvas ref={canvasRef} /></div>;
};

export default EngineScene;
